<template>
  <div>
    <div
      class="modal show fade modal text-left "
      style="display: block;"
      v-if="show"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Details
            </h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="$emit('hide')"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div class="card-body" v-if="typeof list != 'undefined'">
                <div class="d-flex align-items-center pb-3 border-bottom mb-3">
                  <div class="mr-auto">
                    <h6 class="fs-16 font-w600 mb-0">
                      <a
                        href="javascript:void(0)"
                        class="text-warning  font-weight-bolder"
                        >User Id</a
                      >
                    </h6>
                  </div>
                  <span
                    style="font-size: larger"
                    class=" font-weight-bolder text-dark"
                    >{{ list.uuid }}</span
                  >
                </div>
                <div class="d-flex align-items-center pb-3 border-bottom mb-3">
                  <div class="mr-auto">
                    <h6 class="fs-16 font-w600 mb-0">
                      <a
                        href="javascript:void(0)"
                        class="text-warning  font-weight-bolder"
                        >Email</a
                      >
                    </h6>
                  </div>
                  <span
                    style="font-size: larger"
                    class=" font-weight-bolder text-dark"
                    >{{ list.email }}</span
                  >
                </div>
                <div class="d-flex align-items-center pb-3 border-bottom mb-3">
                  <div class="mr-auto">
                    <h6 class="fs-16 font-w600 mb-0">
                      <a
                        href="javascript:void(0)"
                        class="text-warning  font-weight-bolder"
                        >Phone Number</a
                      >
                    </h6>
                  </div>
                  <span
                    style="font-size: larger"
                    class=" font-weight-bolder text-dark"
                    >{{ list.phone_number }}</span
                  >
                </div>
                <div class="d-flex align-items-center pb-3 border-bottom mb-3">
                  <div class="mr-auto">
                    <h6 class="fs-16 font-w600 mb-0">
                      <a
                        href="javascript:void(0)"
                        class="text-warning  font-weight-bolder"
                        >First Name</a
                      >
                    </h6>
                  </div>
                  <span
                    style="font-size: larger"
                    class=" font-weight-bolder text-dark"
                    >{{ list.first_name }}</span
                  >
                </div>
                <div class="d-flex align-items-center pb-3 border-bottom mb-3">
                  <div class="mr-auto">
                    <h6 class="fs-16 font-w600 mb-0">
                      <a
                        href="javascript:void(0)"
                        class="text-warning  font-weight-bolder"
                        >Last Name</a
                      >
                    </h6>
                  </div>
                  <span
                    style="font-size: larger"
                    class=" font-weight-bolder text-dark"
                    >{{ list.last_name }}</span
                  >
                </div>
                <div class="d-flex align-items-center pb-3 border-bottom mb-3">
                  <div class="mr-auto">
                    <h6 class="fs-16 font-w600 mb-0">
                      <a
                        href="javascript:void(0)"
                        class="text-warning  font-weight-bolder"
                        >Time/Date</a
                      >
                    </h6>
                  </div>
                  <span
                    style="font-size: larger"
                    class=" font-weight-bolder text-dark"
                    >{{
                      new Date(list.created_at)
                        .toISOString()
                        .slice(0, 16)
                        .replace("T", " ")
                    }}</span
                  >
                </div>
              </div>
              <div class="card-body text-center text-primary" v-else>
                No Details Avaliable
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="$emit('hide')"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ["show", "userData", "index"],
  data() {
    return {
      list: []
      // showModal: false,
    };
  },
  watch: {
    show() {
      this.list = this.userData;
    },
  }
};
</script>

<style scoped>
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>

